import script from "./MobileTabBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileTabBar.vue?vue&type=script&lang=ts&setup=true"

import "./MobileTabBar.vue?vue&type=style&index=0&id=0c94d706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c94d706"]])

export default __exports__